import * as stylex from '@stylexjs/stylex'
import { type ComponentProps } from 'react'

export const CART_LIST_SCROLLER_ID = 'aiCartListScroller'
const styles = stylex.create({
  root: {
    margin: '0 -2px',
    // fix for ListItem border width
    padding: 2,
    gap: 12,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    maxHeight: '50vh',
    overflowX: 'auto',
  },
})

export type CartListScrollerProps = ComponentProps<'div'>

export const CartListScroller = (props: CartListScrollerProps) => {
  return (
    <div id={CART_LIST_SCROLLER_ID} {...stylex.props(styles.root)} {...props} />
  )
}
